import React, { useEffect, useMemo } from 'react';
import { TableContextProvider, useTableControls } from '../../../../common/components/table/table-context';
import { useMedia } from '../../../../common/hooks/use-media/use-media.hook';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import eiqConnectStore from '../../store/eiq-connect.store';
import { observer } from 'mobx-react-lite';
import { IAccessCardRead, IResidentAddresses } from '../../../../common/services/residents-service/residents.service.types';
import { SelectAll } from 'features/eiq-connect/constants/common.constant';
import { accessCardsListConfig } from './access-cards.config';
import { AccessCardsList } from './access-cards-list';
import { AccessCardDetails } from './access-card-details';

const AccessCards = observer(() => {
  const { isMobile } = useMedia();
  const navigate = useNavigate();

  const data = useMemo(() => {
    const selectedAddresses = eiqConnectStore.selectedAddressesId;
    const isAll = !selectedAddresses || selectedAddresses?.length === 0 || selectedAddresses?.[0] === SelectAll;

    if (isAll) {
      return eiqConnectStore.residentDetails?.addresses?.reduce(
        (acc, curr) =>
          acc.concat(
            curr.accessCards.map((i) => {
              return {
                ...i,
                address: curr.address,
              };
            }) as any,
          ),
        [],
      );
    } else if (selectedAddresses?.length > 0) {
      const accessCards: IAccessCardRead[] = [];

      selectedAddresses?.forEach((value) => {
        const index = value as number;

        if (!eiqConnectStore.residentDetails?.addresses[index]) {
          return;
        }

        const currentAddress: IResidentAddresses = { ...eiqConnectStore.residentDetails?.addresses[index] };
        const accessCard = currentAddress.accessCards.map((i) => {
          return {
            ...i,
            address: currentAddress.address,
          };
        });
        accessCards.push(...accessCard);
      });

      return accessCards;
    }

    return [];
  }, [eiqConnectStore.residentDetails, eiqConnectStore.selectedAddressesId]);

  const tableControls = useTableControls({
    onSelectedRow: (row: any) => {
      if (isMobile) {
        navigate(`/eiq-connect/credentials/${row?.id}/view`);
      }
    },
    clientSide: true,
    data: data,
    initialColumns: accessCardsListConfig,
  });

  useEffect(() => {
    if (isMobile) {
      tableControls.hideColumns({
        arrow: true,
        isDeactivated: false,
      });
    } else {
      tableControls.hideColumns({
        arrow: false,
        isDeactivated: true,
      });
    }
  }, [isMobile]);

  const location = useLocation();
  const isBasePath = location.pathname.endsWith('/credentials');
  const isSearchPath = location.pathname.endsWith('/credentials/search');

  return (
    <TableContextProvider controls={tableControls}>
      {(isBasePath || isSearchPath) && <AccessCardsList className={isBasePath || isSearchPath ? null : 'eiq-display-none'} />}
      <Routes>
        <Route path="/:id/view" element={<AccessCardDetails />} />
      </Routes>
    </TableContextProvider>
  );
});

export default AccessCards;
